import React from "react";
import IconPreview from "../BuilderComponents/Preview/IconPreview";
import { parseCustomCss } from "../../Pages/FlexibleLayout/utils";

const LabelPreview = ({ config, classes }) => {
  const customStyles = config?.custom_css ? parseCustomCss(config.custom_css) : {};
  return (
    <div style={{ height: "100%" }} className={`z-text-default ${classes}`}>
      <div style={{ display: "flex", alignItems: "center", gap: "2px", ...customStyles }}>
        {config.icon && <IconPreview icon={config.icon} />}
        <label>{config.name || ""}</label>
      </div>
    </div>
  );
};

export default LabelPreview;
